import FavoriteAnswerConverter from 'scripts/application/dto_converters/favorite_answer_converter';
import fetchSnippetsByIds from './fetch_snippets_by_ids';

export default class FavoriteAnswersGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast(dto) {
    this.context.stores.favoriteAnswerRecords.addOrReplace(FavoriteAnswerConverter.fromDto(dto));
    fetchSnippetsByIds(this.context, [dto.answerId])
      .then(snippets => {
        if (snippets.length > 0) {
          this.context.stores.favoriteAnswers.addOrReplace(snippets[0]);
        }
      })
      .catch(() => {});
  }

  onBroadcastDelete(dto, { answerId }) {
    this.context.stores.favoriteAnswerRecords.remove(answerId);
    this.context.stores.favoriteAnswers.remove(answerId);
  }
}
